function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, $hooks, Object, String, open, unreadCount) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'mp-sh-global-old-chrome': $component.isAttributeEnabled(`is-old-chrome`),
          'mp-sh-global-open': open,
          'mp-sh-global-unread': unreadCount > 0,
        }, {
          'mp-sh-global-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "on": {
            click: $helpers.handleClickDropdown
          },
          "class": {
            'mp-sh-global-button': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-sh-global-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: `smarthub`
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-sh-global-num-unread': true
              },
            }, [__vjadeSafeCode(unreadCount)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((open) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-alert-dropdown", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`open`, false)
            },
            "attrs": {
              'open': true,
              'placement': `right`,
              'project-id': $component.getAttribute(`project-id`),
              'utc-offset': $component.getAttribute(`utc-offset`) || ``,
              'display-context': `GLOBAL`,
              'workspace-id': $component.getAttribute(`workspace-id`),
            },
            "on": {
              alertsMarkedAsRead: $helpers.handleAlertsMarkedAsRead,
              clickedLink: $helpers.handleClickedLink,
              change: $helpers.handleDropMenuChange,
              manageAlerts: $helpers.handleManageAlerts,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined, "unreadCount" in locals ? locals.unreadCount : typeof unreadCount !== "undefined" ? unreadCount : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;